import EmptyState from '../components/EmptyState';

export default function Stories() {
  return (
    <EmptyState
      title="Stories"
      description="Long-form story content for intermediate and advanced learners"
      phase={8}
    />
  );
}
